import React from 'react';

import { toLocale, toCurrency, toPercent } from '../../helpers/numberHelper';
import { calculateMetrics } from 'utils/analytics/metrics';

import VarianceCardItem from '../common/varianceCardItem';

import './totalCard.style.css';

const TotalCard = ({ currency, current, lySpit }) => {
    const rooms = current.rooms.guaranteed;
    const revenue = current.revenue.accommodation.guaranteed;
    const lySpitRooms = lySpit.rooms.guaranteed;
    const lySpitRevenue = lySpit.revenue.accommodation.guaranteed;
    const { availableRoomCount } = current.inventory;

    const { adr, revPar, occupancy } = calculateMetrics(availableRoomCount, rooms, revenue);
    const roomVariance = rooms - lySpitRooms;
    const revenueVariance = revenue - lySpitRevenue;

    return (
        <div className="TotalCard">
            <div className="TotalCardItem">
                <div className="TotalCardItemValue">{toLocale(rooms)}</div>
                <div className="TotalCardItemLabel">Rooms Sold</div>
            </div>
            <div className="TotalCardItem">
                <div className="TotalCardItemValue">{toLocale(lySpitRooms)}</div>
                <div className="TotalCardItemLabel">LY SPIT</div>
            </div>
            <div className="TotalCardItem">
                <VarianceCardItem
                    text="Room Variance"
                    signedAmount={roomVariance}
                    displayAmount={toLocale(roomVariance)}
                />
            </div>
            <div className="TotalCardItemSeparator"></div>
            <div className="TotalCardItem">
                <div className="TotalCardItemValue">{toCurrency(revenue / 100, currency)}</div>
                <div className="TotalCardItemLabel">Revenue</div>
            </div>
            <div className="TotalCardItem">
                <div className="TotalCardItemValue">{toCurrency(lySpitRevenue / 100, currency)}</div>
                <div className="TotalCardItemLabel">LY SPIT</div>
            </div>
            <div className="TotalCardItem">
                <VarianceCardItem
                    text="Revenue Variance"
                    signedAmount={revenueVariance}
                    displayAmount={toCurrency(revenueVariance / 100, currency)}
                />
            </div>
            <div className="TotalCardItemSeparator"></div>
            <div className="TotalCardItem">
                <div className="TotalCardItemValue">{toPercent(occupancy)}</div>
                <div className="TotalCardItemLabel">Occupancy</div>
            </div>
            <div className="TotalCardItem">
                <div className="TotalCardItemValue">{toCurrency(adr / 100, currency, 2)}</div>
                <div className="TotalCardItemLabel">ADR</div>
            </div>
            <div className="TotalCardItem">
                <div className="TotalCardItemValue">{toCurrency(revPar / 100, currency, 2)}</div>
                <div className="TotalCardItemLabel">RevPAR</div>
            </div>
        </div>
    );
};

export default TotalCard;
